import { consumeAttendedTransferCompleted } from './attended-transfer-state'
import { STATE } from './use-session-facade'

export const isOriginalCallAlive = (state: STATE | undefined): boolean => {
  if (state === undefined) return false

  return state === STATE.CONNECTED
    || state === STATE.ONHOLD
    || state === STATE.PROGRESS
    || state === STATE.RINGING
}

export const isAttendedTransferCancelled = (
  transferSessionId: string,
  referToSessionId: string | null,
  originalSessionState: STATE | undefined,
): boolean => {
  if (!referToSessionId || !isOriginalCallAlive(originalSessionState)) return false
  return !consumeAttendedTransferCompleted(transferSessionId)
}
